module.exports = __webpack_public_path__ + "static/media/no_detailimg.57ad8908.jpg";